import React from "react";
import { connect } from "react-redux";
import * as agent from "../agent";
import { formValueSelector, reduxForm, Field, reset, change } from "redux-form";
import { normalizeMoney, formatDate } from "../utility";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import { MaterialTextField } from "./MaterialInput";
import { Credit } from "../constants/enums";
import transactionForm from "./TransactionForm";
import TransactionTable from "./TransactionTable";
import MaterialDatePicker from "./MaterialDatePicker";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

const TransactionForm = connect((state, props) => {
    const { credit, decreaseSum, operations } = props;
    const { side } = credit;
    const decreaseOperation =
        operations.find(o => o.alias === `CREDIT_DECREASE_${side}`) || {};
    const { mustHaveCredit, mustHaveDepartment } = decreaseOperation;
    return {
        isAdmin: state.common.user.permissions.includes("forms-full-access"),
        mustHaveCredit,
        mustHaveDepartment,
        initialValues: {
            manager: state.common.user.id,
            paymentDate: formatDate(new Date()),
            operation: decreaseOperation._id,
            sum: normalizeMoney(decreaseSum),
            vat: 0
        }
    };
})(reduxForm({ form: "transaction-form" })(transactionForm));

class decreaseCredit extends React.Component {
    state = {
        showingModal: false,
        transactions: [],
        managersLoaded: false,
        managers: [],
        counterparties: [],
        counterpartiesLoaded: false,
        accounts: [],
        accountsLoaded: false,
        operations: [],
        operationsLoaded: false,
        decreaseDate: new Date()
    };

    componentWillMount = () => {
        agent.User.managers()
            .then(res =>
                this.setState({ managersLoaded: true, managers: res.managers })
            )
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
        agent.Counterparty.getAll()
            .then(res =>
                this.setState({
                    counterpartiesLoaded: true,
                    counterparties: res
                })
            )
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
        agent.Account.getAll()
            .then(res => this.setState({ accountsLoaded: true, accounts: res }))
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
        agent.Operation.getAll()
            .then(res =>
                this.setState({ operationsLoaded: true, operations: res })
            )
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    handleClick = e => {
        e.preventDefault();
        this.setState({ showingModal: true });
    };
    changeSum = e => {
        const { changeFieldValue, credit: { sum } = {} } = this.props;
        changeFieldValue(
            "newSum",
            normalizeMoney(
                Math.max(
                    0,
                    Math.abs(sum) - Number(e.target.value.replace(/\s/g, ``))
                )
            )
        );
    };
    handleClose = () => this.setState({ showingModal: false });
    addTransaction = data => {
        const { transactions } = this.state;
        const { decreaseSum, dispatch } = this.props;
        const updTransactions = transactions.concat(data);
        this.setState({ transactions: updTransactions });
        const transactionsSum = updTransactions.reduce(
            (p, n) => p + n.sum.replace(/\s/g, ``),
            0
        );
        dispatch(
            change(
                "transaction-form",
                "sum",
                normalizeMoney(Math.max(decreaseSum - transactionsSum, 0))
            )
        );
    };
    deleteTransaction = index => {
        const { transactions } = this.state;
        this.setState({
            transactions: transactions.filter((_, i) => i !== index)
        });
    };
    onCreditDecrease = (creditId, newSum, transactions) => {
        const { updateCredit, dispatch } = this.props;
        const { decreaseDate } = this.state;

        agent.Credit.decrease(creditId, newSum, decreaseDate, transactions)
            .then(res => {
                dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: "Изменения сохранены", type: "success" }
                });
                dispatch(reset("credit-decrease-form"));
                updateCredit(res);
                this.setState({ transactions: [] });
            })
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    changeDecreaseDate = date =>
        this.setState({ decreaseDate: new Date(date) });

    render() {
        const {
            showingModal,
            transactions,
            managersLoaded,
            managers,
            counterparties,
            counterpartiesLoaded,
            accounts,
            accountsLoaded,
            operations,
            operationsLoaded,
            decreaseDate
        } = this.state;
        const { credit, decreaseSum, handleSubmit } = this.props;
        const { _id, type, side, sum } = credit;
        const creditType = Credit.Types[type];

        const transactionsSum = transactions.reduce(
            (p, n) => p + +n.sum.replace(/\s/g, ``),
            0
        );

        const newSum = Math.abs(sum) - decreaseSum;
        const submitEnabled = decreaseSum === transactionsSum;
        const allowedOperations = [`CREDIT_DECREASE_${side}`];

        const processTransactions = () =>
            transactions.map(t => {
                const fOperation =
                    operations.find(o => o._id === t.operation) || {};
                return Object.assign(
                    { ...t },
                    {
                        sum:
                            { DEBIT: 1, CREDIT: -1 }[fOperation.side] *
                            Number(t.sum.replace(/\s/g, ``))
                    }
                );
            });

        return (
            <Paper
                className="common-paper"
                style={{ marginTop: 20, marginBottom: 20 }}
            >
                <form className="common-form common-column">
                    <MaterialDatePicker
                        label="Дата операции"
                        value={decreaseDate}
                        fullsize={true}
                        onChange={this.changeDecreaseDate}
                    />
                    <Field
                        component={MaterialTextField}
                        disabled={true}
                        format={normalizeMoney}
                        endAdornment="₽"
                        name="sum"
                        label="Текущая сумма"
                    />
                    <Field
                        component={MaterialTextField}
                        normalize={normalizeMoney}
                        onChange={this.changeSum}
                        endAdornment="₽"
                        name="decrease"
                        label="Сумма уменьшения"
                    />
                    <Field
                        component={MaterialTextField}
                        disabled={true}
                        format={normalizeMoney}
                        endAdornment="₽"
                        name="newSum"
                        label="Итого"
                    />
                    <Button
                        type="submit"
                        fullWidth
                        onClick={this.handleClick}
                        color="primary"
                        size="large"
                        variant="contained"
                    >
                        К транзакциям
                    </Button>
                    <Dialog
                        maxWidth={false}
                        open={showingModal}
                        onClose={this.handleClose}
                    >
                        <Paper className="common-paper">
                            <Grid container justify="center" spacing={16}>
                                <Grid item className="common-column">
                                    <TransactionForm
                                        allowedOperations={allowedOperations}
                                        creditMode={true}
                                        addTransaction={this.addTransaction}
                                        managersLoaded={managersLoaded}
                                        managers={managers}
                                        accounts={accounts}
                                        accountsLoaded={accountsLoaded}
                                        counterparties={counterparties}
                                        counterpartiesLoaded={
                                            counterpartiesLoaded
                                        }
                                        operations={operations}
                                        operationsLoaded={operationsLoaded}
                                        decreaseSum={decreaseSum}
                                        credit={credit}
                                    />
                                </Grid>
                                <Grid item className="maxwide-column">
                                    {transactions.length > 0 ? (
                                        <TransactionTable
                                            transactions={transactions}
                                            accounts={accounts}
                                            counterparties={counterparties}
                                            operations={operations}
                                            onTransactionDelete={
                                                this.deleteTransaction
                                            }
                                        />
                                    ) : (
                                        <Typography>
                                            Необходимо добавить транзакцию
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid container spacing={16}>
                                <Grid item className="common-column">
                                    <Button
                                        type="submit"
                                        onClick={handleSubmit(data => {
                                            this.onCreditDecrease(
                                                _id,
                                                { CREDIT: -1, DEBIT: 1 }[side] *
                                                    newSum,
                                                processTransactions(
                                                    transactions
                                                )
                                            );
                                            this.handleClose();
                                        })}
                                        fullWidth
                                        color="primary"
                                        disabled={!submitEnabled}
                                        size="large"
                                        variant="contained"
                                    >
                                        Займ уменьшен
                                    </Button>
                                </Grid>
                                <Grid item className="maxwide-column">
                                    {!submitEnabled && (
                                        <Typography>
                                            Чтобы уменьшить {creditType}{" "}
                                            необходимо провести одну или
                                            несколько транзакций на указанную
                                            сумму {normalizeMoney(decreaseSum)}{" "}
                                            ₽
                                        </Typography>
                                    )}
                                    <Typography>
                                        Вы добавили {transactions.length}{" "}
                                        операций уменьшения займа на сумму{" "}
                                        {normalizeMoney(transactionsSum)} ₽
                                    </Typography>
                                    {transactionsSum > decreaseSum && (
                                        <Typography style={{ color: "red" }}>
                                            Сумма транзакций превышает сумму
                                            уменьшения на{" "}
                                            {normalizeMoney(
                                                transactionsSum - decreaseSum
                                            )}{" "}
                                            ₽. Удалите одну или несколько
                                            транзакций уменьшения
                                        </Typography>
                                    )}
                                    {transactionsSum < decreaseSum && (
                                        <Typography style={{ color: "red" }}>
                                            Cумма уменьшения превышает сумму
                                            транзакций на{" "}
                                            {normalizeMoney(
                                                decreaseSum - transactionsSum
                                            )}{" "}
                                            ₽. Добавьте одну или несколько
                                            транзакций уменьшения
                                        </Typography>
                                    )}
                                    {transactionsSum === decreaseSum && (
                                        <Typography>
                                            Cумма уменьшения и сумма транзакций
                                            совпадают. Операция может быть
                                            проведена
                                        </Typography>
                                    )}
                                    <Typography>
                                        Чтобы изменить сумму уменьшения закройте
                                        диалоговое окно
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Dialog>
                </form>
            </Paper>
        );
    }
}

const DecreaseCredit = connect(
    (state, props) => {
        const {
            credit: { sum }
        } = props;
        const decreaseSum = Number(
            `${formValueSelector("credit-decrease-form")(
                state,
                "decrease"
            )}`.replace(/\s/g, ``)
        );
        return {
            decreaseSum,
            initialValues: {
                sum,
                decrease: 0,
                newSum: sum
            }
        };
    },
    dispatch => ({
        changeFieldValue: (field, value) =>
            dispatch(change("credit-decrease-form", field, value))
    })
)(
    reduxForm({ form: "credit-decrease-form", enableReinitialize: true })(
        decreaseCredit
    )
);

export default DecreaseCredit;



// WEBPACK FOOTER //
// ./src/components/DecreaseCredit.js